import { useEffect } from 'react'
import { setHeaderInfo } from '../redux/common/slicers';
import { useDispatch } from 'react-redux';

export default function Page({ title, subtitle, children }) {
    const dispatch = useDispatch();

    useEffect(() => {
        // update title in common redux
        dispatch(setHeaderInfo({ title, subtitle }));
    }, [])
    return children;
}
